import React from 'react'

import { Box, Typography } from "@mui/material"


export default function transmissionColumn() {

	return {
		name: 'automaticName',
		label: 'Transmission',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{value || "Any"}</Typography>
			</Box>,
		}
	}
}